import {
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useWebsiteApi from "../../hooks/useWebsiteApi";
import useShopifyApi from "../../hooks/useShopifyApi";
import { enqueueSnackbar } from "notistack";
import { IDesign } from "../../types";

const CustomBackdrop = styled(Backdrop, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  },
})({
  zIndex: -1,
  "&:empty": {
    display: "flex",
  },
});

const Importer = (props: { cartId: string }) => {
  const websiteApi = useWebsiteApi();
  const shopifyApi = useShopifyApi();
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const newLocation = new URL(window.location.toString());
    newLocation.search = "";

    const load = async () => {
      const { items } = await websiteApi.getCart(props.cartId);

      if (!items) {
        setIsOpen(false);
        window.location.href = newLocation.toString();
        return;
      }

      setIsOpen(true);

      try {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const design: IDesign = {
            ...item?.properties,
            width: item.properties.width.replace(/mm|cm|in/, ""),
            height: item.properties.height.replace(/mm|cm|in/, ""),
            unit: "mm",
            materialSku: item?.properties?.material,
            productSku: item.productSku,
            quantity: item.properties.quantity,
          };

          await shopifyApi.addToCart(
            design,
            (item.properties?.files || []).map((f) => {
              return { id: `graphic://${f}` };
            })
          );

          await websiteApi.removeFromCart(props.cartId, item.properties._id);
        }

        window.location.href = newLocation.toString();
      } catch (err) {
        console.error(err);
        enqueueSnackbar("Error while setting up cart", {
          variant: "error",
        });
      } finally {
        setIsOpen(false);
      }
    };

    load();
  }, [props.cartId]);

  return (
    <Dialog
      open={true}
      maxWidth="sm"
      components={{
        Backdrop: CustomBackdrop,
      }}
      fullScreen={isFullScreen}
      onClose={() => setIsOpen(false)}
    >
      <DialogTitle>Updating your Cart</DialogTitle>
      <DialogContent
        sx={{
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </DialogContent>
    </Dialog>
  );
};

export default Importer;
